import React from "react";
import LayoutClasses from "./Layout.module.css";
import SideNav from "../SideNav/Navbar";
import useStore from "../../store";

import TopNav from "../topNav";
import { useEffect } from "react";
function Layout({ children, Active }) {
    const setActiveTab = useStore((State) => State.setActiveTab);

    useEffect(() => {
        setActiveTab(Active);
    }, []);
    return <>{children}</>;
}

export default Layout;
